import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import MobileAdhesionGak from './gak/MobileAdhesion';
import MobileAdhesionNitro from './nitro/MobileAdhesion';
const MobileAdhesion = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(MobileAdhesionGak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(MobileAdhesionNitro, {
        safety: safety
    });
};
MobileAdhesion.displayName = 'MobileAdhesion';
export default MobileAdhesion;
